import { FIREBASE_API_UPGRADE_DOCS_LINK } from 'modules/mobileApps/constants';
import { WebPushAuthType } from '../types';
import { StyledLink } from './components/styles';
import { TestWebPushFormValues } from './context';

export const WEB_PUSH_INTEGRATION_FORM_DEFAULT_VALUES = {
  authType: WebPushAuthType.FIREBASE_JSON,
  firebaseJsonFile: undefined,
  fcmServerKey: '',
  fcmSenderId: '',
};

export const TEST_PUSH_FORM_DEFAULT_VALUES: TestWebPushFormValues = {
  browserToken: '',
  title: '',
  body: '',
  icon: '',
  clickAction: '',
};

export const JSON_CREDENTIALS_LABEL = 'Upload JSON credentials';
export const JSON_CREDENTIALS_HELP_TEXT = (
  <>
    You can generate JSON credentials in your Firebase console. Visit our{' '}
    <StyledLink href={FIREBASE_API_UPGRADE_DOCS_LINK} rel="noreferrer noopener" target="_blank">
      support docs
    </StyledLink>{' '}
    to learn more.
  </>
);

export const FIREBASE_DEPRECATION_TOOLTIP_CONTENT =
  'Update your Firebase credentials by June 20, 2024, to continue in sending web push in Iterable.';

export const FIREBASE_CONFIGURE_SUCCESS_BANNER_CONTENT = (fileName: string) => (
  <>
    Your <strong>{fileName}</strong> file was saved successfully! To ensure seamless integration, we
    recommend sending a test push notification.
  </>
);

export const BROWSER_TOKEN_LABEL = 'Browser token';
export const TITLE_LABEL = 'Title';
export const BODY_LABEL = 'Body';
export const ICON_LABEL = 'Icon';
export const CLICK_URL_LABEL = 'Click action URL';

export const CONFIGURE_INTEGRATION_HEADER = 'Configure Firebase integration';
export const TEST_PUSH_INTEGRATION_HEADER = 'Test Firebase integration';

export const LEGACY_FIREBASE_TYPE_LABEL = 'Legacy Server Key';
export const FIREBASE_JSON_TYPE_LABEL = 'HTTP V1';
